















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { allSettled } from '@/common/allSettled'
import { mpAppidMap } from '@/config'

enum ScheduleDynamicTypeEnum {
  /** 增项 */
  EM_ADDITION = 'em_addition',
  /** 钣喷 */
  SHEET_SPRAY = 'sheet_spray',
}

const ScheduleDynamicTitleMap = {
  [ScheduleDynamicTypeEnum.EM_ADDITION]: '增项进度',
  [ScheduleDynamicTypeEnum.SHEET_SPRAY]: '钣喷进度'
}

enum ShareOrderViewTypeEnum {
  /** 公众号 */
  WECHAT = 1,
  /** 小程序 */
  MINI_PROGRAM = 2,
}

type IScheduleDynamicEmAdditionItem = {
  biz_type: ScheduleDynamicTypeEnum.EM_ADDITION
  order_id: number
  share_order?: IShareOrder
}

type IScheduleDynamicSheetSprayItem = {
  biz_type: ScheduleDynamicTypeEnum.SHEET_SPRAY
  order_id: number
}

type IScheduleDynamicItem = IScheduleDynamicEmAdditionItem | IScheduleDynamicSheetSprayItem

type IShareOrderWechat = {
  view_type: ShareOrderViewTypeEnum.WECHAT
  url: string
}

type IShareOrderMiniProgram = {
  view_type: ShareOrderViewTypeEnum.MINI_PROGRAM
  appid: string
  scene: string
}

type IShareOrder = IShareOrderWechat | IShareOrderMiniProgram

const Aftersales = namespace('aftersales')

@Component({})
export default class CarScheduleDynamic extends Vue {
  @Aftersales.State('userInfo') userInfo: any;
  @Prop(String) readonly plateNumber!: string;
  @Prop(String) readonly vin!: string;
  @Prop(String) readonly serviceConsultantName!: string;

  loading = false
  list: IScheduleDynamicItem[] = []

  ScheduleDynamicTitleMap = ScheduleDynamicTitleMap

  ScheduleDynamicTypeEnum = ScheduleDynamicTypeEnum

  @Watch('userInfo', { deep: true })
  onUserInfoChange() {
    this.getCarScheduleDynamic()
  }
  @Watch('plateNumber')
  onPlateNumberChange() {
    this.getCarScheduleDynamic()
  }
  @Watch('vin')
  onVinChange() {
    this.getCarScheduleDynamic()
  }

  mounted() {
    this.getCarScheduleDynamic()
  }

  async getCarScheduleDynamic() {
    if ((!this.plateNumber && !this.vin) || !this.userInfo.mobile_number) return
    if (this.loading) return
    try {
      this.loading = true
      const types = [
        ScheduleDynamicTypeEnum.EM_ADDITION,
        ScheduleDynamicTypeEnum.SHEET_SPRAY
      ]
      const params = {
        plate_number: this.plateNumber,
        vin: this.vin,
        mobile_number: this.userInfo.mobile_number
      }
      const ress = await allSettled(types.map(type => this.$rest.aftersales.getCarBusinessDynamicsProgress({ biz_type: type, ...params })))
      this.list = []
      const map = new Map()
      ress.forEach((res) => {
        if (res.status === 'rejected') return
        if (!res.value) return
        const { code, data } = res.value
        if (code) return
        data.dynamic_list.forEach((item: IScheduleDynamicItem) => {
          map.set(data.biz_type, { ...item, biz_type: data.biz_type })
        })
      })
      this.list = Array.from(map.values())
    } finally {
      this.loading = false
    }
  }

  loadingSendChatMessage = false
  sendChatMessageTimeoutTimer: any = null
  /** 发送诊断报告 */
  handleSendReport(item: IScheduleDynamicEmAdditionItem) {
    if (this.loadingSendChatMessage) return
    this.loadingSendChatMessage = true
    const { share_order } = item
    if (!share_order) return
    /**
     * 具体配置参考文档
     * @see https://developer.work.weixin.qq.com/document/path/94349
     */
    let config
    const imgUrl = 'https://images-cdn.lxusercontent.com/permanent/comm/images/em-addition-share.png'

    switch (share_order.view_type) {
      case ShareOrderViewTypeEnum.WECHAT:
        config = {
          msgtype: 'news',
          enterChat: true,
          news: {
            link: share_order.url,
            title: `尊敬的车主，经技师检查，您的爱车有建议维修项目。点击查看`,
            imgUrl,
            desc: `车牌号码：${this.plateNumber}\n服务顾问：${this.serviceConsultantName || '--'}`
          }
        }
        break
      case ShareOrderViewTypeEnum.MINI_PROGRAM:
        config = {
          msgtype: 'miniprogram',
          enterChat: true,
          miniprogram: {
            appid: share_order.appid,
            title: `${this.plateNumber} 车辆诊断报告`,
            imgUrl,
            page: `/modules/Landing/index.html?scene=${encodeURIComponent(share_order.scene)}`
          }
        }
        break
    }
    if (!config) return
    this.$wechat.wx.invoke('sendChatMessage', config, (res: any) => {
      if (!['sendChatMessage:ok', 'sendChatMessage:cancel'].includes(res.err_msg)) this.showToast(`消息发送失败 ${res.err_msg}`)
      this.loadingSendChatMessage = false
      clearTimeout(this.sendChatMessageTimeoutTimer)
      this.sendChatMessageTimeoutTimer = null
    })
    this.sendChatMessageTimeoutTimer = setTimeout(() => {
      this.loadingSendChatMessage = false
      this.sendChatMessageTimeoutTimer = null
    }, 5000)
  }

  loadingViewDetail = false
  viewDetailTimeoutTimer: any = null
  /** 查看详情 */
  handleViewDetail(item: IScheduleDynamicItem) {
    if (this.loadingViewDetail) return
    /**
     * 具体配置参考文档
     * @see https://developer.work.weixin.qq.com/document/path/93098
     */
    let config
    const storeId = this.$store.state.customized.store_config.store_id
    switch (item.biz_type) {
      case ScheduleDynamicTypeEnum.EM_ADDITION:
        config = {
          appid: mpAppidMap.EM_ADDITION,
          path: `/pages/landing/index.html?target=${encodeURIComponent(`112?id=${item.order_id}`)}&storeId=${storeId}`
        }
        break
      case ScheduleDynamicTypeEnum.SHEET_SPRAY:
        config = {
          appid: mpAppidMap.WORKSHOP,
          path: `/modules/Landing/index.html?target=${encodeURIComponent(`115?orderId=${item.order_id}`)}&storeId=${storeId}`
        }
        break
    }
    if (!config) return
    this.loadingViewDetail = true
    this.$wechat.wx.invoke('launchMiniprogram', config, (res: any) => {
      if (res.err_msg !== 'launchMiniprogram:ok') this.showToast(`打开小程序失败 ${res.err_msg}`)
      this.loadingViewDetail = false
      clearTimeout(this.viewDetailTimeoutTimer)
      this.viewDetailTimeoutTimer = null
    })
    this.viewDetailTimeoutTimer = setTimeout(() => {
      this.loadingViewDetail = false
      this.viewDetailTimeoutTimer = null
    }, 5000)
  }
}
